var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameMenuAccordion = function SvgIconStorygameMenuAccordion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5 6 3.124 3.57a.5.5 0 0 0 .752 0L12 6",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgIconStorygameMenuAccordion;